import React, {useEffect, useMemo} from 'react';
import {createPortal} from "react-dom";
import {ToastContainer} from "react-toastify";

const modalRootElement = document.getElementById('toasts')



const ToastsPortal = () => {

    const element = useMemo(() => {
        return document.createElement('div')
    }, [])


    useEffect(() => {

        if (modalRootElement) {
            modalRootElement.appendChild(element)

            return () => {
                modalRootElement.removeChild(element)
            }
        }
    })

    return createPortal(<ToastContainer/>, element)

};

export default ToastsPortal;